import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Gold Tiara Headband (faire.com/product/p_z7fktr7rcu), via the
// authenticated PDP reviews API (verbatim reviewer name/location/text/date —
// nothing paraphrased or invented).
export const review_sw1: FaireReviewEntity = {
  token: "review_sw1",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_z7fktr7rcu",
  productImageUrl:
    "https://cdn.faire.com/fastly/4c0a1688dbce4f1654c7331dd8f0a9f01a4a132ccba55a80bb185eb4a6cc071f.jpeg",
  reviewerName: "China M.",
  reviewerLocation: "Berkeley, CA",
  stars: 5,
  reviewText:
    "sold two pieces while unpacking the shipment - darling stuff as always!",
  reviewDate: "Jan 9, 2024",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-11T21:28:00.000Z",
    importedBy: "entity-db-cli",
  },
};
